/******************************************************************************
 * AppOverlay Hook
 * version: 1.0.1, release: 10.06.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

import React, { useState, useEffect } from 'react';
import './AppOverlay.scss';
import Store from './Store';
import legend_1 from './assets/legend_1.png'
import legend_2 from './assets/legend_2.png'
import legend_3 from './assets/legend_3.png'

let src = [legend_2, legend_3, legend_1, legend_1]


//============================================================================= AppOverlay Hook
export default function AppOverlay() {
	const [buttonText, setButtonText] = useState('Click me, please');

	const [years, selectedYear, project, segment] = Store.use(
		'years', 'selectedYear', 'project', 'segment')


	useEffect(() => {
		console.log('---update');
		return () => {};	//cleanup
	}, []);


	const onSelectYear = e => {
		Store.projectPoints = {}
		Store.dependencies = []
		// Store.set({depMode:-1})

		// setTimeout(() => {
			Store.set({selectedYear:e})
		// }, 0)
	}

	
	return (
		<div className='app-overlay'>
			<div className='app-overlay-period'>
				<div className='app-overlay-period-title'>{Store.getLabel('3D_PERIOD').toUpperCase()}</div>
				<div className='app-overlay-years'>{Object.keys(years).map((e, i) =>
					<div
						className={'app-overlay-year' + (selectedYear === e? ' selected' : '')}
						key={i}
						onClick={() => onSelectYear(e)}
						>{e}</div>
				)}
				<div
					className={'app-overlay-year' + (selectedYear === 'ALL'? ' selected' : '')}
						onClick={() => onSelectYear('ALL')}
						>
						{Store.getLabel('ALL')}
					</div>
				</div>
			</div>

			{(!project && !segment) &&
				<>
					{/* <img className='app-overlay-legend' src={src[depMode]} alt='' /> */}
					<Legend />
				</>
			}
		</div>
	);
}


const labels = [
	['Standard', 'Differenzierung', 'Vorreiter', 'Gamechanger'],
	['-100', '0', '100'],
	['3D_LOW', '3D_HIGH'],
	['3D_LOW', '3D_HIGH'],
]

const titles = ['TYPE_LEGEND', 'NPS_LEGEND', 'IMPACT_LEGEND', 'DAMAGE_LEGEND']

const Legend = () => {
	const depMode = Store.use('depMode')

	return (
		<div className='app-overlay-legend'>
			<div className='legend-title'>{Store.getLabel(titles[depMode])}</div>

			<div className='legend-segment'>
				<span />
				<span />
				<span />
				<span />
			</div>

			<div className='legend-labels'>
				{labels[depMode]?.map(e => <span key={e}>{Store.getLabel(e)}</span>)}
			</div>
		</div>
	)
}